
<template>
  <div>
    <chc-loader ref="loader"></chc-loader>
    <chc-modal ref="addSourceModal" title="New Referral Source">
      <div slot="body">
        <source-add
          :charityId="charityId"
          v-on:refresh="refresh"
          v-on:close="addSourceHide"
          ></source-add>
      </div>
    </chc-modal>
    <chc-modal ref="editSourceModal" title="Edit Source">
      <div slot="body">
        <source-edit
          :data="editData"
          :sourceId="editId"
          v-on:refresh="refresh"
          v-on:close="editSourceHide"
          ></source-edit>
      </div>
    </chc-modal>
    <datatable
        :source="sources"
        :isLoading="isLoading"
      >
      <datatable-column
        v-for='(column, index) in columns'
        :id='column.id'
        :label='column.label'
        :key='index'
        >
      </datatable-column>

      <template slot="searchLeft">
        <a class="secondary-action" v-on:click="addSource">+ Add New Source</a>
      </template>

      <template slot="source_template" slot-scope="data">
          <tr @click="gotoRow(data.row.id)">
              <td>{{ data.row.status }}</td>
              <td>{{ data.row.description }}</td>
          </tr>
      </template>
    </datatable>
  </div>
</template>

<script>
import Datatable from '@/components/Datatables/AppDatatable'
import DatatableColumn from '@/components/Datatables/AppDatatableColumn'
import SourceAdd from '@/components/Source/SourceAdd'
import SourceEdit from '@/components/Source/SourceEdit'
import store from '@/store'

export default {
  name: 'SourceSummary',
  props: ['charityId'],
  mounted () {
    this.refresh()
  },
  data () {
    return {
      columns: [
        { id: 'status', label: 'Status' },
        { id: 'description', label: 'Referral Source Description' },
      ],
      isLoading: true,
      editData: {
        description: '',
        charity_id: '',
        status: ''
      },
      editId: null,
      sources: [],
    }
  },
  components: {
    Datatable,
    DatatableColumn,
    SourceAdd,
    SourceEdit
  },
  methods: {
    gotoRow (rowId) {
      this.$refs.loader.show()
      store.functions.sources.getSource(rowId, (response) => {
        this.editData = response.data
        this.editId = rowId
      }).then(() => {
        this.$refs.loader.hide()
        this.$refs.editSourceModal.show()
      })
    },
    addSource () {
      this.$refs.addSourceModal.show()
    },
    addSourceHide () {
      this.$refs.addSourceModal.hide()
    },
    editSourceHide () {
      this.$refs.editSourceModal.hide()
    },
    refresh () {
      if (!this.charityId) {
        Promise.all([
          store.dispatch('syncConstants'),
          store.functions.sources.sourceTable((response) => { this.sources = response.data })
        ]).finally(() => {
          this.isLoading = false
        })
      } else {
        Promise.all([
          store.dispatch('syncConstants'),
          store.functions.charity.getSourcesTable(this.charityId, (response) => { this.sources = response.data })
        ]).finally(() => {
          this.isLoading = false
        })
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Source/SourceSummary.vue